import BeneficiariesScreen from './BeneficiariesScreen';

export default BeneficiariesScreen;
